import {
  humanTransactionRequestStatus,
  transactionRequestStatus,
} from '../const'
import { ColumnFilterItem } from 'antd/lib/table/interface'

export const withdrawalClientAmountEnabled = function (
  status: string,
): boolean {
  let statuses = [
    transactionRequestStatus.pendingManager(),
    transactionRequestStatus.fundsReserved(),
    transactionRequestStatus.vendorError(),
  ]

  return statuses.includes(status)
}

export const withdrawalFilters = function (): ColumnFilterItem[] {
  return [
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.pendingManager(),
      ),
      value: transactionRequestStatus.pendingManager(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.pendingDestination(),
      ),
      value: transactionRequestStatus.pendingDestination(),
    },
    {
      text: humanTransactionRequestStatus(transactionRequestStatus.accepted()),
      value: transactionRequestStatus.accepted(),
    },
    {
      text: humanTransactionRequestStatus(transactionRequestStatus.rejected()),
      value: transactionRequestStatus.rejected(),
    },
    {
      text: humanTransactionRequestStatus(transactionRequestStatus.ps()),
      value: transactionRequestStatus.ps(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.pendingRollback(),
      ),
      value: transactionRequestStatus.pendingRollback(),
    },
    {
      text: humanTransactionRequestStatus(transactionRequestStatus.questions()),
      value: transactionRequestStatus.questions(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.missingInformation(),
      ),
      value: transactionRequestStatus.missingInformation(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.fundsReserved(),
      ),
      value: transactionRequestStatus.fundsReserved(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.unconfirmed(),
      ),
      value: transactionRequestStatus.unconfirmed(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.vendorError(),
      ),
      value: transactionRequestStatus.vendorError(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.internalError(),
      ),
      value: transactionRequestStatus.internalError(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.pendingAutoCheck(),
      ),
      value: transactionRequestStatus.pendingAutoCheck(),
    },
    {
      text: humanTransactionRequestStatus(
        transactionRequestStatus.dealersCheck(),
      ),
      value: transactionRequestStatus.dealersCheck(),
    },
  ]
}
